import React from 'react';
import { paraQuem } from '../data/mock';

export default function ParaQuem() {
  return (
    <section id="paraquem" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 text-center">
          <p className="text-[11px] tracking-widest-2 text-[color:var(--gold-400)] uppercase mb-4">
            Para quem
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.4rem] text-[color:var(--cream-100)] leading-tight">
            Para quem é este{' '}
            <span className="italic text-[color:var(--gold-400)]">trabalho.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {paraQuem.map((p) => (
            <div
              key={p.number}
              className="p-8 md:p-10 border border-[color:var(--gold-500)]/20 rounded-lg bg-[color:var(--brown-800)]/50 hover:border-[color:var(--gold-400)]/50 transition-colors"
            >
              <span className="font-serif italic text-2xl text-[color:var(--gold-400)]/80">
                {p.number}
              </span>
              <div className="w-10 h-px bg-[color:var(--gold-400)]/40 my-6"></div>
              <h3 className="font-serif text-2xl md:text-[1.7rem] text-[color:var(--cream-100)] leading-tight">
                {p.title}
              </h3>
              <p className="mt-5 text-[color:var(--cream-100)]/70 leading-relaxed">
                {p.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
